import React, { useEffect, useState } from 'react';
import { dealAPI, productAPI } from './SellerApi';

export const SellerDeals = () => {
  const [deals, setDeals] = useState([]);
  const [products, setProducts] = useState([]);
  const [form, setForm] = useState({ product_id: '', discount_pct: '', label: '', starts_at: '', ends_at: '' });
  const [loading, setLoading] = useState(true);
  const [success, setSuccess] = useState('');

  useEffect(() => {
    Promise.all([dealAPI.list(), productAPI.list()])
      .then(([d, p]) => { 
        setDeals(d.data || []); 
        setProducts(p.data || []); 
      })
      .catch(() => {
        setDeals([{ id: 1, product_name: 'Designer Casual Shoes', discount_pct: 20, label: 'Mega Sale Week', ends_at: '2026-06-30', status: 'active' }]);
        setProducts([{ id: 1, name: 'Designer Casual Shoes' }, { id: 2, name: 'Waterproof Smartwatch' }]);
      })
      .finally(() => setLoading(false));
  }, []);

  const handleCreate = async (e) => {
    e.preventDefault();
    try {
      const res = await dealAPI.create(form);
      setDeals(d => [res.data, ...d]);
      setSuccess('Deal activated successfully!');
      setForm({ product_id: '', discount_pct: '', label: '', starts_at: '', ends_at: '' });
      setTimeout(() => setSuccess(''), 3000);
    } catch (err) {
      console.error(err);
    }
  };

  const removeDeal = (id) => {
    dealAPI.delete(id)
      .then(() => setDeals(ds => ds.filter(x => x.id !== id)))
      .catch(console.error);
  };

  return (
    <div className="sp-deals-wrapper">
      <div className="sp-card">
        <div className="sp-card-title">Launch New Store Discount Campaign</div>
        {success && <div className="sp-alert success" style={{ marginBottom: '1rem' }}>{success}</div>}
        <form onSubmit={handleCreate} className="sp-form-grid">
          <div className="sp-input-group">
            <label className="sp-label">Target Inventory Item</label>
            <select className="sp-select" value={form.product_id} onChange={e => setForm({ ...form, product_id: e.target.value })} required>
              <option value="">-- Choose Item --</option>
              {products.map(p => <option key={p.id} value={p.id}>{p.name}</option>)}
            </select>
          </div>
          <div className="sp-input-group">
            <label className="sp-label">Markdown Discount Percentage (%)</label>
            <input type="number" className="sp-input" placeholder="e.g. 15" min="1" max="99" value={form.discount_pct} onChange={e => setForm({ ...form, discount_pct: e.target.value })} required />
          </div>
          <div className="sp-input-group">
            <label className="sp-label">Campaign Tracking Label</label>
            <input type="text" className="sp-input" placeholder="e.g. Clearance Sale" value={form.label} onChange={e => setForm({ ...form, label: e.target.value })} />
          </div>
          <div className="sp-input-row">
            <div className="sp-input-group">
              <label className="sp-label">Starts At</label>
              <input type="date" className="sp-input" value={form.starts_at} onChange={e => setForm({ ...form, starts_at: e.target.value })} />
            </div>
            <div className="sp-input-group">
              <label className="sp-label">Ends At</label>
              <input type="date" className="sp-input" value={form.ends_at} onChange={e => setForm({ ...form, ends_at: e.target.value })} />
            </div>
          </div>
          <button type="submit" className="sp-btn-primary" style={{ marginTop: '0.5rem' }}>Push Campaign Live</button>
        </form>
      </div>

      <div className="sp-card" style={{ marginTop: '1.5rem' }}>
        <div className="sp-card-title">Active Promotional Campaigns</div>
        {loading ? <div className="sp-skeleton" style={{ height: 120 }} /> : (
          <div className="sp-deals-grid">
            {deals.map(d => (
              <div key={d.id} className="sp-deal-card">
                <div className="sp-deal-top">
                  <div>
                    <div className="sp-deal-name">{d.product_name}</div>
                    {d.label && <div className="sp-deal-meta">{d.label}</div>}
                  </div>
                  <span className="sp-deal-disc">{d.discount_pct}% OFF</span>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginTop: 12 }}>
                  <span className={`sp-badge ${d.status}`}>{d.status}</span>
                  <span style={{ fontSize: 11, color: 'var(--t3)' }}>Ends {d.ends_at ? new Date(d.ends_at).toLocaleDateString('en-IN') : '—'}</span>
                </div>
                <button className="sp-btn-danger" style={{ width: '100%', marginTop: '1rem', fontSize: 12 }} onClick={() => removeDeal(d.id)}>
                  Terminate Campaign
                </button>
              </div>
            ))}
            {deals.length === 0 && <p style={{ color: 'var(--t3)', textAlign: 'center', padding: '1rem' }}>No promotional campaigns currently running.</p>}
          </div>
        )}
      </div>
    </div>
  );
};